var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-container"},[_c('van-image',{attrs:{"width":"100%","fit":"contain","src":_vm.insureImgUrl}}),_vm._v(" "),(_vm.flag==1)?_c('div',{staticClass:"button-save"},[_c('van-button',{attrs:{"type":"primary","block":"","color":"#fe5958"},on:{"click":_vm.handleGoClick}},[_vm._v("《委托授权书》")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d342f80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/insurance/letter_book.vue
// module id = null
// module chunks = 